import { iconButtonCompoundVariants, iconButtonDisabledVariants, iconButtonEmphasisVariants, iconButtonShadowVariants, iconButtonSizeVariants, iconButtonSlots, iconButtonTypeVariants } from "../../variants/index.js";
import { tv } from "../../variants/tv.js";
const iconButtonVariants = tv({
    slots: iconButtonSlots,
    variants: {
        type: iconButtonTypeVariants,
        size: iconButtonSizeVariants,
        emphasis: iconButtonEmphasisVariants,
        shadow: iconButtonShadowVariants,
        disabled: iconButtonDisabledVariants,
        active: {
            true: {}
        },
        fillNone: {
            true: {
                iconSlot: 'fill-none'
            }
        }
    },
    compoundVariants: iconButtonCompoundVariants,
    defaultVariants: {
        type: 'secondary',
        emphasis: 'regular',
        size: 'md',
        disabled: false
    }
});
export { iconButtonVariants };
